<template>
  <div class="promotion-container">
    <mer-steps :stepConfig="stepConfig" :currentStep="currentStep"></mer-steps>
    <first v-show="currentStep === 1" @submit="submit" />
    <second v-if="currentStep === 2" :qrUrl="qrUrl" :recordId="recordId" @nextStep="nextStep" />
    <third v-if="currentStep === 3" :qrStatus="qrStatus" :activeType="9" :activeTime="activeTime" />
  </div>
</template>
<script>
import { submitInfo } from '@/api/runAchieve/signUp'
import merSteps from '@/components/work/MerStep'
import first from './first'
import second from './second'
import third from './third'

export default {
  components: {
    merSteps,
    first,
    second,
    third
  },
  data () {
    return {
      stepConfig: [
        { step: 1, title: '填写信息' },
        { step: 2, title: '扫码绑定' },
        { step: 3, title: '报名完成' }
      ],
      currentStep: 1,
      qrUrl: null,
      recordId: null,
      qrStatus: null,
      activeTime: []
    }
  },
  methods: {
    async submit (form) {
      try {
        const { code, result: { qrUrl, recordId } } = await submitInfo(form)
        if (code !== 200) return
        this.qrUrl = qrUrl
        this.recordId = recordId
        this.currentStep = 2
        this.activeTime = [form.startDate, form.endDate]
      } catch (error) {
        console.log(error)
      }
    },
    nextStep (qrStatus) {
      this.currentStep = 3
      this.qrStatus = qrStatus
    }
  }
}
</script>
<style lang="less" scoped>
  .promotion-container {
    padding: 30px 40px;
    background-color: #fff;
    height: 100%;
  }
</style>
